<template>
  <div id="done_customer_offer" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLiveLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content closefriend-modal" style="background-color: #1a1a1a; border: 1px solid rgba(255,255,255,0.1); border-radius: 16px;">
        <div class="modal-header border-0 align-items-center pb-2">
          <h4 class="modal-title mx-auto font-size-16 font-weight-bold text-white">Congrats!</h4>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" style="position: absolute; right: 20px; opacity: 0.8; text-shadow: none;">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body text-center pt-0 px-4 pb-4">
          <div class="form-group text-center mb-2">
            <div class="mx-auto mb-4 mt-3 text-center">
              <p class="font-size-14 text-white mb-4" style="line-height: 1.5; opacity: 0.9;">
                Your request has been submitted! It may take several days for the creator to <span style="color: #ff6ec7;">{{accepted ? 'complete.' : 'accept, decline, or send a counter.'}}</span>
              </p>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-center mt-3">
              <button @click="done()"
                      class="btn rounded-pill font-weight-bold px-4 py-2 font-size-14 text-dark w-100 m-0"
                      style="background: linear-gradient(135deg, #ff6ec7, #f9a826); border: none;">
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {customerCustomRequestMixin} from "@/mixin/customer-custom-request-mixin";

export default {
  name: "ModelCustomerCustomRequestDone",
  mixins: [customerCustomRequestMixin],
  data() {
    return {
      accepted: false
    }
  },
  methods: {
    show(customRequest, accepted = false) {
      this.clearMessages();
      this.accepted = accepted;
      this.customRequest = customRequest;
      $('#done_customer_offer').modal();
    },
    hide() {
      $('#done_customer_offer').modal('hide');
    },
    done() {
      this.hide();
      this.$emit("doneCustomRequest", this.customRequest);
    }
  }
}
</script>


